export default __webpack_public_path__ + "static/media/cp_zs_zscaler.dd60f2b7.svg";